import { useTranslations } from 'languages';
import { CategoryLayout } from 'modules/pages/CategoryPersonalPage';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { CategoryPersonalPropsType } from 'types/pages/CategoryPersonalPropsType';
import { siteText } from '../../siteText';

export const CategoryPersonalPage: FC<CategoryPersonalPropsType> = ({
  metaCategory,
  categoryData,
}) => {
  const t = useTranslations();

  const { locale = '' } = useRouter();

  const { seo = {} } = { ...categoryData[0] };

  const { title: metaTitle = '', description = '', keywords = '' } = metaCategory;

  const {
    title_en = '',
    title_ru = '',
    title_uk = '',
    slug_en = '',
    slug_ru = '',
    slug_uk = '',
  } = seo;

  const categoryTagTitle =
    locale === 'ru' ? title_ru : locale === 'uk' ? title_uk : title_en;

  const metaForCategoryPersonalPage = {
    title:
      metaTitle || `${t('metaCosmetology.title')} ${categoryTagTitle} - pro.bhub.com.ua`,
    description:
      description ||
      `${t('metaCosmetology.descriptionFirstPart')} ${categoryTagTitle} ${t(
        'metaCosmetology.descriptionSecondPart'
      )}`,
    keywords: keywords || '',
    slugs: {
      slug_en: `category/${slug_en}`,
      slug_ru: `category/${slug_ru}`,
      slug_uk: `category/${slug_uk}`,
    },
  };

  return (
    <CategoryLayout
      siteText={siteText}
      metaForCategoryPersonalPage={metaForCategoryPersonalPage}
      categoryData={categoryData}
    />
  );
};
export default CategoryPersonalPage;
